import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Topnavbar from './Header-pages/Topnavbar';
import Navbar from './Header-pages/Navbar';
import Homepage from './Header-pages/Homepage';
import Technologies from './Header-pages/Technologies';
import SafproAbout from './Header-pages/SafproAbout';
import Services from './Header-pages/Services';
import BusinessSolution from './Header-pages/BusinessSolution';
import AgileWorkflow from './Header-pages/AgileWorkFlow';
import Whychooseus from './Header-pages/Whychooseus';
import Ourlatestworks from './Header-pages/Ourlatestworks';
import Reviewsection from './Header-pages/Reviewsection';
import Blogs from './Header-pages/Blogs';
import Footer from './Header-pages/Footer';
import PlanTable from './Header-pages/PlanTable';

const Main = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we have a section to scroll to from navigation
    if (location.state && location.state.scrollTo) {
      const sectionId = location.state.scrollTo;

      // Small delay to ensure the page is fully rendered
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }

        // Clear the navigation state to prevent scrolling on refresh
        window.history.replaceState({ ...location.state, scrollTo: null }, '');
      }, 100);
    }
  }, [location]);

  return (
    <div>
      <Topnavbar />
      <Navbar />

      {/* Home section - scrolls to top */}
      <div id="home">
        <Homepage />
      </div>

      {/* About Us section */}
      <div id="about-us">
        <SafproAbout />
      </div>
      <Technologies />
      {/* Services section */}
      <div id="services">
        <Services />
      </div>

      <div id="products">
        <BusinessSolution />
      </div>
      <AgileWorkflow />

      {/* Why Choose Us section */}
      <div id="why-choose-us">
        <Whychooseus />
      </div>

      <Ourlatestworks />

      <Reviewsection />


      {/* Blogs section */}
      <div id="blogs">
        <Blogs />
      </div>

      <PlanTable />

      <div id="contact">
        <Footer />
      </div>
    </div>
  );
};

export default Main;